/**
 * Whether navigating back stays inside the app. The Navigation API's
 * `canGoBack` only counts contiguous same-origin entries, so it is exact
 * where supported; older WebKit falls back to the history-length heuristic
 * (which can be true for cross-origin entries — the pre-existing behavior).
 */
export function canGoBackInApp(): boolean {
  if (typeof window === "undefined") return false;
  const nav = (window as { navigation?: { canGoBack?: boolean } }).navigation;
  if (nav && typeof nav.canGoBack === "boolean") return nav.canGoBack;
  return window.history.length > 1;
}
